import { PropsWithChildren } from 'react';

import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { ThemeProvider } from '@silverfort/sf-components';

const theme = createTheme({
    palette: {
        primary: {
            main: '#188ded'
        }
    }
});

export const ThemeContext = ({ children }: PropsWithChildren<object>) => {
    return (
        <MuiThemeProvider theme={theme}>
            <ThemeProvider>{children}</ThemeProvider>
        </MuiThemeProvider>
    );
};
